import script from "./NavPlant.vue?vue&type=script&setup=true&lang=js"
export * from "./NavPlant.vue?vue&type=script&setup=true&lang=js"

import "./NavPlant.vue?vue&type=style&index=0&id=3c59525d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\RebO\\Documents\\Github\\Projekt\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c59525d"]])

export default __exports__